import { useEffect, useState } from "react";
import Modal from "react-modal";
import { AGButton, CloseIcon } from "./style";

export interface DeleteConfirmModalProps {
    visible: boolean;
    toggleModal: () => void;
    onDelete: () => void;
    type?: number;
    deletedService?: () => void;
    text: string;
}
const DeleteConfirmModal = ({
    visible,
    toggleModal,
    onDelete,
    deletedService,
    type,
    text
}: DeleteConfirmModalProps) => {
    const handleClose = () => {
        toggleModal();
    };
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const customStyles = {
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            borderRadius: 10,
            padding: "20px 20px 0px ",
            width: screenWidth < 540 ? "90%" : 500,
            fontFamily:
                "Roboto, Nunito, Arial, Helvetica, sans-serif, Arial, sans-serif",
        },
        overlay: {
            zIndex: 99999999999,
        },
    };
    return (
        <Modal
            isOpen={visible}
            style={customStyles}
            contentLabel="Example Modal">
            <CloseIcon onClick={handleClose}>✖</CloseIcon>
            <div
                style={{
                    fontSize: 16,
                    fontWeight: 600,
                }}>
                Delete inquiry
            </div>
            <div style={{ marginTop: 16, fontSize: 14 }}>
                Are you sure you want to permanently delete this inquiry?
            </div>
            <div
                style={{
                    margin: "20px 0 10px auto",
                    width: "100%",
                    textAlign: "right",
                }}>
                <AGButton
                    className="mr-[5px]"
                    onClick={handleClose}
                    style={{ background: "#D9D9D9 " }}>
                    Cancel
                </AGButton>
                <AGButton onClick={() => onDelete()}>Delete</AGButton>
            </div>
        </Modal>
    );
};

export default DeleteConfirmModal;
